export const BLEEPS_CATEGORIES = {
    background: 'background',
    transition: 'transition',
    interaction: 'interaction',
    notification: 'notification'
};
